<template>
    <div class="xbk_checkout_wrap">
        <div class="delivery_info fc">
            <h3>配送地址</h3>
            <div
                v-if="addressList && addressList.length != 0 && selectedAddress"
                class="info fr ac"
                @click="toAddressList"
            >
                <img
                    class="location_icon"
                    src="../../../static/imgs/kfc/location_kfc.png"
                    alt
                />
                <div class="fc">
                    <p class="receiver_info">
                        <span class="receiver">{{
                            selectedAddress.realname
                        }}</span>
                        <span class="phone">{{ selectedAddress.mobile }}</span>
                    </p>
                    <p class="address">
                        {{ selectedAddress.provincename }}
                        {{ selectedAddress.cityname }}
                        {{ selectedAddress.countyname }}
                        {{ selectedAddress.address }}
                    </p>
                </div>
            </div>
            <div
                v-if="!addressList || addressList.length == 0"
                class="info fr ac jsb"
                @click="addAddress"
            >
                <div class="fr ac">
                    <img
                        class="location_icon"
                        src="../../../static/imgs/kfc/location_kfc.png"
                        alt
                    />
                    <span class="add_address">请填写配送地址</span>
                </div>
                <img
                    src="../../../static/imgs/kfc/right.png"
                    class="right_icon"
                    alt
                />
            </div>
        </div>
        <div class="order_detail fc">
            <h3>饮品详情</h3>
            <div
                class="order_item fr ac jsb"
                v-for="(item, index) in cartArr"
                :key="index"
            >
                <div class="product_info fr ac">
                    <img
                        :src="imgBaseUrl + item.logo"
                        alt=""
                        class="product_img"
                    />
                    <div class="fc">
                        <h4 class="product_name">{{ item.name }}</h4>
                        <span class="product_prop">{{ item.propsTxt }}</span>
                    </div>
                </div>
                <div class="price_wrap fr ac">
                    <span class="product_price">￥{{ item.realPrice }}</span>
                    <span class="product_qty">×{{ item.qty }}</span>
                </div>
            </div>
            <div class="price_bar">
                共1件，小计：<span>￥{{ cartTotal }}</span>
            </div>
        </div>
        <div class="footer fr ac jsb">
            <h4>
                ￥{{ cartTotal * 1 + expressfee * 1
                }}<span>（包含{{ expressfee }}元配送费）</span>
            </h4>
            <button @click="createOrder">确认支付</button>
        </div>
    </div>
</template>

<script>
import { Toast } from "mint-ui";
export default {
    data() {
        return {
            imgBaseUrl: this.$global.imgBaseUrl,
            cartArr: [],
            addressList: [],
            cartTotal: 0,
            expressfee: 0,
        };
    },
    components: {},
    created() {},
    activated() {
        this.cartTotal = this.$route.query.cartTotal
            ? this.$route.query.cartTotal
            : 0;
        this.expressfee = this.$route.query.expressfee
            ? this.$route.query.expressfee
            : 0;
        this.cartArr = this.getLocal("xbkCartArr");
        this.getAddressList();
    },
    methods: {
        addAddress() {
            this.$router.push("/newAddress");
        },
        toAddressList() {
            this.$router.push("/addressList");
        },
        getAddressList() {
            this.$post({
                method: "member.drama.express.address.list",
                auth_code: this.getLocal("auth_code"),
            }).then((res) => {
                if (res.success) {
                    this.addressList = res.data.addresslist;
                    if (this.addressList && this.addressList.length > 0) {
                        this.defaultAddress = this.addressList[0];
                    }

                    for (let i of res.data.addresslist) {
                        if (i.isdefault == "Y") {
                            this.defaultAddress = i;
                            break;
                        }
                    }

                    this.selectedAddress = this.getLocal("selectedAddress")
                        ? this.getLocal("selectedAddress")
                        : this.defaultAddress;

                    console.log(this.selectedAddress);
                }
            });
        },
        createOrder() {
            if (!this.selectedAddress.id || !this.addressList.length) {
                Toast({
                    message: "请先填写配送地址",
                    position: "middle",
                    duration: 2000,
                    className: "toastBox",
                });
                return;
            }

            let cartArr = this.cartArr;
            let jsonArr = [];
            for (let i of cartArr) {
                let obj = {};
                obj.productid = i.id;
                obj.qty = i.qty;
                obj.attrvalueIds = i.propsIds;
                jsonArr.push(obj);
            }
            this.$post({
                method: "starbucks.member.waisong.order.create",
                auth_code: this.getLocal("auth_code"),
                addressid: this.selectedAddress.id,
                createOrderJson: JSON.stringify(jsonArr),
            }).then((res) => {
                if (res.success) {
                    this.setLocal("xbkCartArr", []);
                    let appkey = this.$global.appkey;
                    if (
                        appkey == "dumovie_iOS" ||
                        appkey == "dumovie_Android"
                    ) {
                        window.location.href =
                            "dumovie://com.dumovie/order/pay/meishi/" +
                            res.data.tradeno;
                    } else {
                        this.$router.replace({
                            path: "/confirmOrder",
                            query: {
                                tradeno: res.data.tradeno,
                                orderType: "MS",
                                isKfc: "",
                            },
                        });
                    }
                } else {
                    Toast({
                        message: res.error.desp,
                        position: "middle",
                        duration: 2000,
                        className: "toastBox",
                    });
                }
            });
        },
    },
};
</script>
<style scoped lang="scss">
.xbk_checkout_wrap {
    .delivery_info {
        margin-bottom: 20px;
        h3 {
            width: 100%;
            padding: 0 30px;
            box-sizing: border-box;
            height: 80px;
            line-height: 80px;
            font-size: 32px;
            font-weight: bold;
            background: #fff;
            border-bottom: 1px solid #dededf;
        }
        .info {
            width: 100%;
            padding: 0 30px;
            box-sizing: border-box;
            height: 145px;
            background: #fff;
            font-size: 28px;
            .location_icon {
                width: 66px;
                height: 66px;
                margin-right: 20px;
            }
            .receiver_info {
                margin-bottom: 8px;
                .receiver {
                    margin-right: 10px;
                }
            }
            .address {
                color: #999;
                line-height: 36px;
            }
            .add_address {
                color: #d62f35;
            }
            .right_icon {
                width: 9px;
                height: 17px;
            }
        }
    }
    .order_detail {
        margin-bottom: 20px;
        h3 {
            width: 100%;
            padding: 0 30px;
            box-sizing: border-box;
            height: 80px;
            line-height: 80px;
            font-size: 32px;
            font-weight: bold;
            background: #fff;
            border-bottom: 1px solid #dededf;
        }
        .order_item {
            background: #fff;
            width: 100%;
            padding: 0 30px;
            box-sizing: border-box;
            height: 100px;
            font-size: 28px;
            border-bottom: 1px solid #dededf;
            .product_info {
                img {
                    width: 80px;
                    height: 80px;
                    margin-right: 20px;
                    border-radius: 10px;
                }
                .product_prop {
                    font-size: 22px;
                    color: #999;
                    margin-top: 8px;
                }
            }
            .price_wrap {
                .product_qty {
                    margin-left: 20px;
                    color: #999;
                }
            }
        }
        .price_bar {
            width: 100%;
            padding: 0 30px;
            box-sizing: border-box;
            height: 80px;
            line-height: 80px;
            font-size: 28px;
            background: #fff;
            text-align: right;
            span {
                color: #d62f35;
            }
        }
    }
    .footer {
        width: 100%;
        height: 120px;
        background: #fff;
        position: fixed;
        bottom: 0;
        h4 {
            margin-left: 30px;
            font-size: 32px;
            color: #d62f35;
            span {
                font-size: 28px;
                color: #333;
            }
        }
        button {
            width: 250px;
            text-align: center;
            background: #d62f35;
            font-size: 32px;
            color: #fff;
            border-radius: 0;
            height: 120px;
            line-height: 120px;
            padding: 0 40px;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/xbk/xbkCheckout.vue